import { render, staticRenderFns } from "./CheckoutArea.vue?vue&type=template&id=cb048bc4"
import script from "./CheckoutArea.vue?vue&type=script&lang=js"
export * from "./CheckoutArea.vue?vue&type=script&lang=js"
import style0 from "./CheckoutArea.vue?vue&type=style&index=0&id=cb048bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports